import React,{useEffect, useState} from "react";
import { Trans, useTranslation} from 'react-i18next'

function WalletSettings({toogleOption,toogleTaskbar}){
const {t, i18n } = useTranslation();

useEffect(()=>{
    toogleOption(4)
},[])

 return (
    <div style={{display:'flex',flexDirection:'column',paddingBottom:'2.5em',borderRadius:'8px',marginLeft:'2.5em',marginTop:'1.5em',width:'93.28%',backgroundImage:' linear-gradient(174.92deg, rgba(204, 204, 255, 0.08) 2.03%, rgba(204, 204, 255, 0.08) 2.03%, rgba(204, 204, 255, 0.08) 2.04%, rgba(204, 204, 255, 0.04) 91.48%)'}}>
        <div className="MembershipTxt">{t('Walletheader')}</div>     
        <div className="ProfileSettingHeader" style={{marginLeft:'5.5em',marginTop:'2em'}}>
            Coming Soon
        </div>    
    </div>
 )
}

export default WalletSettings;